export const appendAndClause = (where, clause) => ({
  ...where,
  AND: [...(where.AND || []), clause],
});

export const buildTracerClause = (tracerIds, tracerTarget) => {
  if (!tracerIds.length) return null;
  const branches =
    tracerTarget === "subscription"
      ? tracerIds.map((id) => ({ project: { tracer: { id } } }))
      : tracerIds.map((id) => ({ tracer: { id } }));
  return { OR: branches };
};
